import { ListboxPopover, ListboxOption } from '@reach/listbox';
import React__default, { useMemo, Children } from 'react';
import styled from 'styled-components';
import { setTestId } from '../../lib/testId.js';
import { CSSDefaultPopover, CSSDefaultOption } from '../inputs/InputCommon.js';
import { Text } from '../text/Text.js';

/**
 * ListboxOptions don't accept an empty value, so to provide a deselect option we must
 * match on a special string.
 */ const SELECT_OPTION_NO_VALUE = "NO_VALUE";
/**
 * Styled components
 */ const SelectPopover = styled(ListboxPopover)`
  &[data-reach-listbox-popover] {
    ${CSSDefaultPopover}
  }

  &[data-reach-listbox-popover] > [data-hpy-web-select-field-listbox-list] {
    max-height: 14rem;
    overflow: auto;
  }
`;
const StyledListboxOption = styled(ListboxOption)`
  &[data-reach-listbox-option] {
    ${CSSDefaultOption}
  }
`;
/**
 * Select field helper functions
 */ const useSelectedLabel = (children, field)=>useMemo(()=>{
        let selectedChildLabel = null;
        Children.forEach(children, (child)=>{
            if (child && child.props.value === field.value) {
                selectedChildLabel = child.props.label;
            }
        });
        return selectedChildLabel;
    }, [
        children,
        field.value
    ]);
/**
 * Select field components
 */ const DEPRECATED_SelectOption = ({ label , value , testId ="X" , children , ...props })=>{
    return React__default.createElement(StyledListboxOption, {
        "data-hpy-web-select-option": true,
        ...setTestId("SelectOption-" + testId),
        ...props,
        label: label,
        value: value
    }, !!children ? children : React__default.createElement(Text, {
        weight: "semibold"
    }, label));
};
DEPRECATED_SelectOption.dataId = "data-hpy-web-select-option";
DEPRECATED_SelectOption.displayName = "SelectOption";

export { DEPRECATED_SelectOption, SELECT_OPTION_NO_VALUE, SelectPopover, useSelectedLabel };
